/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Edit_SubmitInputs */



/**
* | output |
* | --- |
* | "Save" |
*
* @param {Developer_Edit_SubmitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_edit_submit = /** @type {((inputs?: Developer_Edit_SubmitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Edit_SubmitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salvar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva")
	return /** @type {LocalizedString} */ ("Save")
});